import React, { useState } from 'react';
import useScoll from '@/context/UseScrollHeight';
import styles from './index.module.less';
import Image from 'next/image';
import dayjs from 'dayjs';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'next-i18next';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';
import classNames from 'classnames';
import { useUserProvider } from '@/context/UserProvider';
import { message } from 'antd';
import { getGoogleTrendDataApi } from '@/lib/service/erasa';
import dynamic from 'next/dynamic';
import CompetionHead from '../competion-head';
import VaryData from './varous-data';
import RelationTopics from './Relation-Topics';
const SearchNow = dynamic(() => import('@/components/[platform]-vs-[platform]/SearchNow'), {
  ssr: false,
});
const FooterStart = dynamic(() => import('./FooterStart'));
const FloatHeadTop = dynamic(() => import('@/components/FloatHeadTop'), {
  ssr: false,
});
const GoogleTrend = dynamic(() => import('./GoogleTrence/index'), {
  ssr: false,
});

const Index = ({
  platListItem,
  sixPlatList,
  googleTrendData,
}: {
  platListItem: any;
  sixPlatList: any;
  googleTrendData: any;
}) => {
  const { isMobile } = useConfigProvider();
  const scrollPosition = useScoll();
  const { t } = useTranslation();
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const [googleTrendDataTemp, setgoogleTrendDataTemp] = useState(googleTrendData);
  const handleUpdate = () => {
    if (isLogin) {
      getGoogleTrendDataApi(platListItem.platform).then((res) => {
        if (res.code === 0) {
          setgoogleTrendDataTemp(res?.data || {});
          message.success(
            t(`Your update request has been received! We're working on bringing you the latest site information.`),
          );
        } else {
          message.error(t(res.message));
        }
      });
    } else {
      onOpenLoginModal(true);
    }
  };
  return (
    <div className={styles.container}>
      {/* 浮窗 */}
      <FloatHeadTop />
      <div className={styles.head}>
        <CompetionHead type={1} />
      </div>
      <div className={styles.content}>
        <div className={styles.tag_head_time}>
          <ul
            className={classNames(styles.tagList, {
              [styles.fix]: scrollPosition > 300 && isMobile,
              [styles.relactve]: scrollPosition <= 300 || !isMobile,
            })}
          >
            <li>
              <a href="#Basic Information">{t('Overview')}</a>
            </li>
            <li>
              <a href="#Data Comparison">{t('Data Comparison')}</a>
            </li>
            <li>
              <a href="#Popular Topics">{t('Popular Topics')}</a>
            </li>
            <li>
              <a href="#Comparison with Other Platforms">{t('Comparison with Other Platforms')}</a>
            </li>
          </ul>
          <div>
            {t('Last Updated:')}
            <span>{dayjs().format('YYYY-MM-DD')}</span>
          </div>
        </div>
        <h2
          className={styles.title}
          id="Basic Information"
          style={{
            scrollMarginTop: isMobile ? '100px' : '200px',
            fontFamily: 'Inter-700',
          }}
        >
          {capitalizeFirstLetter(platListItem.platform)}: {t('Overview')}
        </h2>
        <div className={styles.content_head}>
          <Image src={platListItem.icon} alt={platListItem.platform} height={30} priority width={30} />
          <span>{capitalizeFirstLetter(platListItem.platform)}</span>
        </div>
        <div className={styles.description}>{t(platListItem.description)}</div>
        <div className={styles.url}>
          URL:
          <span onClick={() => window.open(platListItem.url, '_blank')}>{platListItem.url}</span>
        </div>
        <ul className={styles.i_tag}>
          <span>{t('tags')}:</span>
          {platListItem.tags.map((item: string, index: number) => (
            <li key={index}>{t(item)}</li>
          ))}
        </ul>
        <h2
          className={styles.t_head}
          id="Data Comparison"
          style={{
            scrollMarginTop: isMobile ? '100px' : '200px',
            fontFamily: 'Inter-700',
          }}
        >
          <span style={{ fontFamily: 'Inter-700' }}>{capitalizeFirstLetter(platListItem.platform)}</span>
          {t('Data Comparison')}
        </h2>
      </div>

      <div className={classNames(styles.mobileshow)}>
        <VaryData platListItem={platListItem} />
      </div>
      <div className={classNames(styles.content, styles.pcshow)}>
        <VaryData platListItem={platListItem} />
      </div>
      <div className={styles.content}>
        <SearchNow></SearchNow>
      </div>
      <div className={styles.content}>
        <div
          className={styles.theme_head}
          id="Popular Topics"
          style={{ scrollMarginTop: isMobile ? '100px' : '200px' }}
        >
          <h2>
            <span style={{ fontFamily: 'Inter-700' }}>{capitalizeFirstLetter(platListItem.platform)}</span>
            {t('Popular Topics')}
          </h2>
          <div style={{ fontSize: '16px' }}>
            {t('Last Updated:')}
            <span>{googleTrendDataTemp[0]?.date || dayjs().format('YYYY-MM-DD')}</span>
            <Image
              onClick={handleUpdate}
              style={{
                cursor: 'pointer',
                verticalAlign: 'sub',
                height: '18px',
                marginLeft: '5px',
              }}
              height={18}
              width={18}
              src="/images/common/blut-upload.png"
              alt="upgrade"
              loading="lazy"
            />
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className={styles.google_trend}>
          <GoogleTrend googleTrendData={googleTrendDataTemp} />
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.google_trend}>
            <GoogleTrend googleTrendData={googleTrendDataTemp} />
          </div>
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.related_topics}>
          <RelationTopics platListItem={platListItem} sixPlatList={sixPlatList} />
        </div>
      </div>

      <FooterStart />
    </div>
  );
};

export default Index;
